import React, { useState } from 'react';
import { Product } from '../types';
import { featuredProductService } from '../services/featuredProductService';
import ProductSearchSelect from './ProductSearchSelect';

interface AddFeaturedProductFormProps {
    availableProducts: Product[];
    onProductAdded: () => void;
}

const AddFeaturedProductForm: React.FC<AddFeaturedProductFormProps> = ({
    availableProducts,
    onProductAdded
}) => {
    const [selectedProduct, setSelectedProduct] = useState<number | null>(null);
    const [adding, setAdding] = useState(false);

    const handleAddProduct = async () => {
        if (!selectedProduct) {
            alert('Veuillez sélectionner un produit');
            return;
        }

        setAdding(true);
        try {
            await featuredProductService.addFeaturedProduct({
                productId: selectedProduct,
                displayOrder: 1 // Will be set by backend based on current count
            });

            setSelectedProduct(null);
            onProductAdded();
            alert('Produit ajouté aux produits en vedette avec succès !');
        } catch (error: any) {
            alert(error.message || 'Erreur lors de l\'ajout du produit');
        } finally {
            setAdding(false);
        }
    };

    return (
        <div className="bg-white rounded-lg shadow-md p-6 mb-6">
            <h2 className="text-xl font-bold text-eldai-blue mb-4">
                ➕ Ajouter un produit en vedette
            </h2>

            <div className="mb-2 text-sm text-gray-600">
                {availableProducts.length} produit(s) disponible(s) pour ajout
            </div>

            <div className="flex flex-col sm:flex-row gap-4">
                <div className="flex-1">
                    <ProductSearchSelect
                        products={availableProducts}
                        selectedProduct={selectedProduct}
                        onProductSelect={setSelectedProduct}
                        placeholder="Rechercher et sélectionner un produit..."
                    />
                </div>
                <button
                    onClick={handleAddProduct}
                    disabled={!selectedProduct || adding}
                    className="bg-eldai-yellow text-eldai-blue px-6 py-2 rounded-lg font-semibold hover:bg-eldai-blue hover:text-white transition-colors disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap"
                >
                    {adding ? 'Ajout...' : 'Ajouter'}
                </button>
            </div>
        </div>
    );
};

export default AddFeaturedProductForm;
